import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Importation des fichiers de traduction
import frTranslations from "./locales/fr/translation.json";
import enTranslations from "./locales/en/translation.json";
import esTranslations from "./locales/es/translation.json";
import ruTranslations from "./locales/ru/translation.json";

// Validation des traductions en développement
import "./utils/validateTranslations";

const resources = {
  fr: {
    translation: frTranslations,
  },
  en: {
    translation: enTranslations,
  },
  es: {
    translation: esTranslations,
  },
  ru: {
    translation: ruTranslations,
  },
};

i18n
  // Détection automatique de la langue
  .use(LanguageDetector)
  // Intégration avec React
  .use(initReactI18next)

  // Configuration
  .init({
    resources,
    fallbackLng: "en", // Langue par défaut
    lng: undefined, // Laisser le détecteur choisir
    // debug: process.env.NODE_ENV === 'development',

    // Langues supportées
    supportedLngs: ["en", "fr", "es", "ru"],
    nonExplicitSupportedLngs: true,

    // Options de détection de langue
    detection: {
      order: [
        "querystring",
        "localStorage",
        "navigator",
        "htmlTag",
        "path",
        "subdomain",
      ],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
      lookupQuerystring: "lang",
      lookupFromPathIndex: 0,
      lookupFromSubdomainIndex: 0,
    },

    interpolation: {
      escapeValue: false, // React échappe déjà les valeurs
    },

    // Options de formatage
    react: {
      useSuspense: false,
      bindI18n: "languageChanged loaded",
      bindI18nStore: "added removed",
      transEmptyNodeValue: "",
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
    },

    // Amélioration des erreurs
    saveMissing: process.env.NODE_ENV === "development",
    missingKeyHandler: (lng, ns, key, fallbackValue) => {
      if (process.env.NODE_ENV === "development") {
        // console.warn(`🔍 Clé de traduction manquante: [${lng}] ${key}`);
      }
    },
  });

export default i18n;
